import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-web-solutions',
  templateUrl: './web-solutions.component.html',
  styleUrls: ['./web-solutions.component.scss']
})
export class WebSolutionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.scrollTo(0, 0)
  }

}
